(function () {
  const BOTTOMLINE_SELECTOR = '.yotpo-widget-instance[data-yotpo-instance-id="603923"]';
  const REVIEWS_SELECTOR = '.yotpo-widget-instance[data-yotpo-instance-id="603583"]';
  const REVIEWS_TAB_BTN_ID = 'tab_reviews_yotpo';
  const TAB_TRANSITION_MS = 350;
  const SCROLL_OFFSET = 20;

  function getHeaderHeight() {
    const header = document.querySelector('.header-section header[is="sticky-header"]');
    return header ? Math.round(header.offsetHeight) : 0;
  }

  function scrollToReviews() {
    const reviewsWidget = document.querySelector(REVIEWS_SELECTOR);
    if (!reviewsWidget) return;
    const top =
      reviewsWidget.getBoundingClientRect().top +
      window.pageYOffset -
      getHeaderHeight() -
      SCROLL_OFFSET;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  function activateReviewsTabAndScroll() {
    const tabBtn = document.getElementById(REVIEWS_TAB_BTN_ID);
    if (!tabBtn) {
      scrollToReviews();
      return;
    }

    const tabsComponent = tabBtn.closest('tabs-component');
    const panelId = tabBtn.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const alreadyActive = panel && !panel.hasAttribute('hidden');

    if (alreadyActive) {
      scrollToReviews();
      return;
    }

    if (tabsComponent && typeof tabsComponent.setActiveTab === 'function') {
      const index = Number(tabBtn.dataset.index || 0);
      tabsComponent.setActiveTab(index);
    } else {
      tabBtn.click();
    }

    setTimeout(scrollToReviews, TAB_TRANSITION_MS);
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest(BOTTOMLINE_SELECTOR);
    if (!trigger) return;
    activateReviewsTabAndScroll();
  });
})();
